module.exports = __webpack_public_path__ + "img/1573629050.820cc612.jpg";